import {formatDate} from "@ui-seeker/utils";


export default function embargoDateColumn() {
	return {
		name: 'embargoDate',
		label: 'Embargo Date',
		options: {
			headerAlign: 'left',
			customBodyRowRender: value => formatDate(value, { isString: true })
		}
	}
}